(function () {
  'use strict';
  var megamenu;
  var activePanelId = null;
  var scrollFadeBound = false;
  var scrollTicking = false;
  var lastScrollY = 0;
  var megamenuCloseTimer = null;
  var megamenuDocumentListenersBound = false;

  /* ===========================================
     Scroll direction — show on up, hide on down.
     The navbar and the info-bar fade together as one
     unit so the merchant never sees one without the
     other. On the shop page (when the FILTER|SORT|VIEW
     stack is rendered), nav+info stay hidden once the
     shopper has scrolled past the top, even on scroll
     up — otherwise they reappear directly below the
     sticky filter bar.
     =========================================== */
  function setNavHidden(navbar, infobar, hidden) {
    navbar.classList.toggle('is-hidden', hidden);
    if (infobar) infobar.classList.toggle('is-hidden', hidden);
  }

  function applyNavbarScrollBehavior() {
    var navbar = document.querySelector('.custom-navbar');
    if (!navbar) return;
    var infobar = document.querySelector('.info-bar');

    var stickyNoFade = navbar.getAttribute('data-sticky-no-fade') === 'true';
    if (stickyNoFade || navbar.classList.contains('megamenu-active')) {
      setNavHidden(navbar, infobar, false);
      lastScrollY = window.pageYOffset;
      return;
    }

    var y = window.pageYOffset || document.documentElement.scrollTop;
    if (y < 0) y = 0;

    if (y <= 10) {
      setNavHidden(navbar, infobar, false);
    } else if (y > lastScrollY + 2) {
      setNavHidden(navbar, infobar, true);
    } else if (y < lastScrollY - 2) {
      setNavHidden(navbar, infobar, false);
    }

    lastScrollY = y;
  }

  function initScrollFade() {
    lastScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;

    if (!scrollFadeBound) {
      window.addEventListener('scroll', function () {
        if (megamenu && megamenu.classList.contains('is-open')) {
          closeMegamenu();
        }
        if (!scrollTicking) {
          requestAnimationFrame(function () {
            applyNavbarScrollBehavior();
            scrollTicking = false;
          });
          scrollTicking = true;
        }
      });
      scrollFadeBound = true;
    }

    applyNavbarScrollBehavior();
  }

  /* ===========================================
     Cart Drawer
     =========================================== */
  var drawer, body, subtotalEl;

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function initCartDrawer() {
    drawer = document.querySelector('.custom-cart-drawer');
    if (!drawer) return;

    body = drawer.querySelector('[data-cart-body]');
    subtotalEl = drawer.querySelector('[data-cart-subtotal]');

    document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
      btn.addEventListener('click', openDrawer);
    });

    document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });

    var overlay = drawer.querySelector('[data-cart-overlay]');
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    drawer.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');

      if (minus) {
        var key = minus.getAttribute('data-key');
        var qty = parseInt(minus.closest('.custom-cart-drawer__item').querySelector('.custom-cart-drawer__qty-val').textContent, 10);
        changeQty(key, Math.max(0, qty - 1));
      }

      if (plus) {
        var key2 = plus.getAttribute('data-key');
        var qty2 = parseInt(plus.closest('.custom-cart-drawer__item').querySelector('.custom-cart-drawer__qty-val').textContent, 10);
        changeQty(key2, qty2 + 1);
      }
    });
  }

  /* ---------- Cart API helpers ---------- */

  function changeQty(key, quantity) {
    var request;

    if (quantity === 0) {
      request = fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (currentCart) {
          var parent = currentCart.items.find(function (item) { return item.key === key; });
          var linkId = parent && parent.properties ? parent.properties._addon_link_id : '';
          var updates = {};
          updates[key] = 0;

          if (linkId) {
            currentCart.items.forEach(function (item) {
              if (isFeeItem(item) && item.properties && item.properties._linked_to_id === linkId) {
                updates[item.key] = 0;
              }
            });
          }

          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates }),
          }).then(function (r) { return r.json(); });
        });
    } else {
      request = fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity }),
      }).then(function (r) { return r.json(); });
    }

    request
      .then(function (cart) {
        renderCart(cart);
        updateCount(visibleItemCount(cart));
      })
      .catch(function (err) {
        console.error('[custom-navbar] cart change error', err);
      });
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        updateCount(visibleItemCount(cart));
      })
      .catch(function (err) {
        console.error('[custom-navbar] cart fetch error', err);
      });
  }

  function updateCount(n) {
    document.querySelectorAll('.custom-navbar__cart-count').forEach(function (el) {
      el.textContent = n;
    });
  }

  function shopCurrency() {
    var active =
      window.Shopify && window.Shopify.currency && window.Shopify.currency.active
        ? window.Shopify.currency.active
        : 'TRY';
    return String(active).toUpperCase().replace(/[^A-Z]/g, '') || 'TRY';
  }

  function money(cents) {
    var currency = shopCurrency();
    var sourceCents = Math.round(Number(cents) || 0);
    var formatted;

    try {
      formatted = new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency,
      }).format(sourceCents / 100);
    } catch (e) {
      formatted = (sourceCents / 100).toFixed(2) + ' ' + currency;
    }

    return '<span class="money" doubly-currency="' + currency + '" doubly-currency-' +
      currency.toLowerCase() + '="' + sourceCents + '">' + esc(formatted) + '</span>';
  }

  function syncDrawerCurrency(attempt) {
    var converter = window.DoublyGlobalCurrency;
    var currencySelect = document.querySelector('[name="doubly-currencies"]');
    var targetCurrency = currencySelect && currencySelect.value
      ? currencySelect.value
      : shopCurrency();

    if (converter && typeof converter.convertAll === 'function') {
      converter.convertAll(targetCurrency, '.custom-cart-drawer .money');
      return;
    }

    if ((attempt || 0) < 20) {
      window.setTimeout(function () {
        syncDrawerCurrency((attempt || 0) + 1);
      }, 100);
    }
  }

  function esc(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  // Variant titles built from hex-coded colour swatch values (e.g.
  // "#E9D54A #7FB6C9") are display-only colour chips on the product page —
  // strip those tokens so the cart shows clean text (or nothing) instead.
  function cleanVariantTitle(title) {
    if (!title) return '';
    return title
      .split(' / ')
      .filter(function (part) {
        return part.indexOf('#') === -1;
      })
      .join(' / ');
  }

  function isFeeItem(item) {
    var properties = item && item.properties ? item.properties : {};
    return String(properties._hide_in_cart) === 'true' ||
      item.handle === 'initial-printing-fee' ||
      item.handle === 'gift-wrap-fee';
  }

  function visibleItemCount(cart) {
    return cart.items.reduce(function (count, item) {
      return isFeeItem(item) ? count : count + item.quantity;
    }, 0);
  }

  function linkedFeesFor(cart, parent) {
    var linkId = parent.properties && parent.properties._addon_link_id;
    if (!linkId) return [];

    return cart.items.filter(function (item) {
      return isFeeItem(item) && item.properties && item.properties._linked_to_id === linkId;
    });
  }

  function addonRows(fees) {
    var totals = {
      initial: { quantity: 0, total: 0 },
      gift: { quantity: 0, total: 0 },
      other: { quantity: 0, total: 0 },
    };

    fees.forEach(function (fee) {
      var group = fee.handle === 'initial-printing-fee'
        ? totals.initial
        : fee.handle === 'gift-wrap-fee'
          ? totals.gift
          : totals.other;
      group.quantity += fee.quantity;
      group.total += fee.final_line_price;
    });

    var rows = '';
    [
      { label: 'INITIAL EMBROIDERY', value: totals.initial },
      { label: 'Gift wrap', value: totals.gift },
      { label: 'Additional service', value: totals.other },
    ].forEach(function (entry) {
      if (!entry.value.total) return;
      rows +=
        '<div class="custom-cart-drawer__addon">' +
          '<span class="custom-cart-drawer__addon-label">' + esc(entry.label) + ' × ' + entry.value.quantity + '</span>' +
          '<span class="custom-cart-drawer__addon-price">+' + money(entry.value.total) + '</span>' +
        '</div>';
    });

    return rows ? '<div class="custom-cart-drawer__addons" aria-label="Product add-ons">' + rows + '</div>' : '';
  }

  function renderCart(cart) {
    if (!body) return;

    var parentItems = cart.items.filter(function (item) { return !isFeeItem(item); });

    if (parentItems.length === 0) {
      body.innerHTML = '<p class="custom-cart-drawer__empty">Your cart is empty</p>';
    } else {
      var html = '';
      parentItems.forEach(function (item) {
        var fees = linkedFeesFor(cart, item);
        var consolidatedTotal = fees.reduce(function (total, fee) {
          return total + fee.final_line_price;
        }, item.final_line_price);
        var variantTitle = cleanVariantTitle(item.variant_title);
        var variant = variantTitle
          ? '<span class="custom-cart-drawer__item-variant">' + esc(variantTitle) + '</span>'
          : '';

        var img = item.featured_image && item.featured_image.url
          ? '<img src="' + item.featured_image.url + '&width=150" alt="' + esc(item.product_title) + '" width="75" height="75" loading="lazy">'
          : '';

        html +=
          '<div class="custom-cart-drawer__item" data-line-key="' + item.key + '">' +
            '<div class="custom-cart-drawer__item-image">' + img + '</div>' +
            '<div class="custom-cart-drawer__item-info">' +
              '<a href="' + item.url + '" class="custom-cart-drawer__item-title">' + esc(item.product_title) + '</a>' +
              variant +
              addonRows(fees) +
              '<div class="custom-cart-drawer__item-bottom">' +
                '<div class="custom-cart-drawer__qty">' +
                  '<button type="button" class="custom-cart-drawer__qty-btn" data-qty-minus data-key="' + item.key + '">−</button>' +
                  '<span class="custom-cart-drawer__qty-val">' + item.quantity + '</span>' +
                  '<button type="button" class="custom-cart-drawer__qty-btn" data-qty-plus data-key="' + item.key + '">+</button>' +
                '</div>' +
                '<span class="custom-cart-drawer__item-price">' + money(consolidatedTotal) + '</span>' +
              '</div>' +
            '</div>' +
          '</div>';
      });
      body.innerHTML = html;
    }

    if (subtotalEl) subtotalEl.innerHTML = money(cart.total_price);

    window.requestAnimationFrame(function () {
      syncDrawerCurrency(0);
    });

    document.dispatchEvent(new CustomEvent('garaia:cart-updated', { detail: { cart: cart } }));
  }
  /* ===========================================
     Mega Menu — hover opens, click navigates
     =========================================== */
  function clearMegamenuCloseTimer() {
    if (megamenuCloseTimer) {
      window.clearTimeout(megamenuCloseTimer);
      megamenuCloseTimer = null;
    }
  }

  function scheduleMegamenuClose() {
    clearMegamenuCloseTimer();
    megamenuCloseTimer = window.setTimeout(function () {
      closeMegamenu();
    }, 120);
  }

  function initMegamenu() {
    megamenu = document.querySelector('.custom-megamenu');
    if (!megamenu) return;

    var navbar = document.querySelector('.custom-navbar');
    if (!navbar || navbar.dataset.megamenuBound === 'true') return;
    navbar.dataset.megamenuBound = 'true';

    var navLinks = document.querySelectorAll('.custom-navbar__link[data-block-id]');

    navLinks.forEach(function (link) {
      var blockId = link.getAttribute('data-block-id');
      var panel = megamenu.querySelector('[data-megamenu-panel="' + blockId + '"]');

      if (!panel) {
        link.addEventListener('mouseenter', closeMegamenu);
        link.addEventListener('focus', closeMegamenu);
        return;
      }

      link.addEventListener('mouseenter', function () {
        clearMegamenuCloseTimer();
        openMegamenu(blockId, navbar, navLinks);
      });

      link.addEventListener('focus', function () {
        clearMegamenuCloseTimer();
        openMegamenu(blockId, navbar, navLinks);
      });
    });

    navbar.addEventListener('mouseenter', clearMegamenuCloseTimer);
    navbar.addEventListener('mouseleave', scheduleMegamenuClose);
    megamenu.addEventListener('mouseenter', clearMegamenuCloseTimer);
    megamenu.addEventListener('mouseleave', scheduleMegamenuClose);

    if (!megamenuDocumentListenersBound) {
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && megamenu && megamenu.classList.contains('is-open')) {
          closeMegamenu();
        }
      });

      document.addEventListener('click', function (e) {
        if (!megamenu || !megamenu.classList.contains('is-open')) return;
        if (e.target.closest('.custom-megamenu') || e.target.closest('.custom-navbar')) return;
        closeMegamenu();
      });

      megamenuDocumentListenersBound = true;
    }
  }

  function openMegamenu(blockId, navbar, navLinks) {
    megamenu.querySelectorAll('.custom-megamenu__panel').forEach(function (p) {
      p.style.display = 'none';
    });

    var target = megamenu.querySelector('[data-megamenu-panel="' + blockId + '"]');
    if (target) target.style.display = '';

    megamenu.classList.add('is-open');
    megamenu.setAttribute('aria-hidden', 'false');
    activePanelId = blockId;

    if (navbar) navbar.classList.add('megamenu-active');

    navLinks.forEach(function (l) {
      l.classList.toggle('is-active', l.getAttribute('data-block-id') === blockId);
    });
  }

  function closeMegamenu() {
    if (!megamenu) return;
    clearMegamenuCloseTimer();
    megamenu.classList.remove('is-open');
    megamenu.setAttribute('aria-hidden', 'true');
    activePanelId = null;

    var navbar = document.querySelector('.custom-navbar');
    if (navbar) navbar.classList.remove('megamenu-active');

    document.querySelectorAll('.custom-navbar__link[data-block-id]').forEach(function (l) {
      l.classList.remove('is-active');
    });

    lastScrollY = window.pageYOffset || document.documentElement.scrollTop;
    applyNavbarScrollBehavior();
  }

  /* ===========================================
     Cart-count sync (intercept other add-to-cart)
     =========================================== */
  function initCartSync() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCount(cart.item_count);
          });
      });
    }
  }

  /* ===========================================
     Mobile Menu
     =========================================== */
  var mobileMenu;

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function resetMobileMenuToRoot() {
    if (!mobileMenu) return;
    mobileMenu.querySelectorAll('.custom-navbar__mobile-panel--submenu.is-active').forEach(function (p) {
      p.classList.remove('is-active');
      p.setAttribute('aria-hidden', 'true');
    });
  }

  function initMobileMenu() {
    mobileMenu = document.querySelector('.custom-navbar__mobile-menu');
    if (!mobileMenu) return;

    document.querySelectorAll('[data-mobile-menu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', openMobileMenu);
    });

    /* Multiple close buttons (one per panel) all dismiss the entire menu. */
    mobileMenu.querySelectorAll('[data-mobile-menu-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeMobileMenu();
        /* After the slide-out animation, reset to root so the next open
           starts at level 1 — matches the auralee.jp pattern where users
           don't see stale submenu state. */
        setTimeout(resetMobileMenuToRoot, 350);
      });
    });

    /* Tapping a nav_link with children — slide its panel in from the right. */
    mobileMenu.querySelectorAll('[data-mobile-panel-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panelId = btn.getAttribute('data-mobile-panel-open');
        var panel = mobileMenu.querySelector('[data-mobile-panel="' + panelId + '"]');
        if (!panel) return;
        panel.classList.add('is-active');
        panel.setAttribute('aria-hidden', 'false');
      });
    });

    /* Back button on a submenu panel — slide it back out to the right. */
    mobileMenu.querySelectorAll('[data-mobile-panel-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.closest('.custom-navbar__mobile-panel--submenu');
        if (!panel) return;
        panel.classList.remove('is-active');
        panel.setAttribute('aria-hidden', 'true');
      });
    });

    /* Tapping any actual link (root nav-link without children, view-all,
       or a submenu_link) navigates away — close the menu so the user
       doesn't see it overlay the new page during the transition. */
    mobileMenu.querySelectorAll('a.custom-navbar__mobile-nav-link, a.custom-navbar__mobile-sub-link').forEach(function (link) {
      link.addEventListener('click', function () {
        closeMobileMenu();
        setTimeout(resetMobileMenuToRoot, 350);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('is-open')) {
        closeMobileMenu();
        setTimeout(resetMobileMenuToRoot, 350);
      }
    });
  }

  /* ===========================================
     Global side inquiry fallback

     The homepage/catalog can include a page-level a-garaia-side-inquiry
     section. Other pages still need mobile menu #inquire links to open the
     drawer instead of navigating to the homepage anchor, so the navbar renders
     a hidden fallback drawer and this controller chooses the page-level drawer
     first when one exists.
     =========================================== */
  function getSideInquiryRoot() {
    return (
      document.querySelector('.side-inquiry:not(.side-inquiry--global)') ||
      document.querySelector('.side-inquiry--global')
    );
  }

  function openSideInquiry(root) {
    if (!root) return;
    root.classList.remove('is-peek');
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeSideInquiry(root) {
    if (!root) return;
    root.classList.remove('is-open', 'is-peek');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function syncSideInquiryBody(root) {
    var bodyInput = root.querySelector('[data-si-body]');
    if (!bodyInput) return;

    var company = root.querySelector('[data-field="company"]');
    var city = root.querySelector('[data-field="city"]');
    var message = root.querySelector('[data-field="message"]');
    var newsletter = root.querySelector('[data-field="newsletter"]');
    var parts = [];

    if (company && company.value) parts.push('Company: ' + company.value);
    if (city && city.value) parts.push('City: ' + city.value);
    if (message && message.value) parts.push('Message: ' + message.value);
    if (newsletter && newsletter.checked) parts.push('Opted in to newsletter');

    bodyInput.value = parts.join('\n');
  }

  function initSideInquiryFallback() {
    document.querySelectorAll('.side-inquiry[data-si-root]').forEach(function (root) {
      if (root.dataset.navbarSiBound === 'true') return;
      root.dataset.navbarSiBound = 'true';

      root.querySelectorAll('[data-si-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          closeSideInquiry(root);
        });
      });

      var form = root.querySelector('form');
      if (form) {
        form.addEventListener('submit', function () {
          sessionStorage.setItem('garaia_si_submitted', '1');
          syncSideInquiryBody(root);
        });
      }
    });

    if (document.documentElement.dataset.navbarSiGlobalBound !== 'true') {
      document.documentElement.dataset.navbarSiGlobalBound = 'true';

      document.addEventListener('click', function (e) {
        if (!e.target.closest) return;
        var trigger = e.target.closest('a[href*="#inquire"], [data-side-inquiry-open]');
        if (!trigger) return;

        var root = getSideInquiryRoot();
        if (!root) return;

        e.preventDefault();
        closeMobileMenu();
        setTimeout(resetMobileMenuToRoot, 350);
        openSideInquiry(root);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        document.querySelectorAll('.side-inquiry.is-open').forEach(function (root) {
          closeSideInquiry(root);
        });
      });
    }

    if (sessionStorage.getItem('garaia_si_submitted') === '1') {
      sessionStorage.removeItem('garaia_si_submitted');
      var submittedRoot = getSideInquiryRoot();
      if (submittedRoot) {
        submittedRoot.classList.add('is-submitted');
        openSideInquiry(submittedRoot);
      }
    }
  }

  /* ===========================================
     <cart-notification> stub for product-form.js integration.

     Dawn's product-form.js looks for <cart-notification> or <cart-drawer>
     on form submit; if neither exists, it redirects to /cart. We register
     a minimal element whose renderContents() opens our custom drawer
     (which then refetches /cart.js to show the freshly-added line item).
     =========================================== */
  if (!customElements.get('cart-notification')) {
    customElements.define(
      'cart-notification',
      class CartNotificationStub extends HTMLElement {
        getSectionsToRender() {
          return [];
        }
        setActiveElement(element) {
          this.activeElement = element;
        }
        renderContents() {
          openDrawer();
        }
      }
    );
  }

  /* ===========================================
     Add-to-cart drawer interception.

     Garaia's product page (and any Dawn-style add-to-cart form) uses a
     plain <form action="/cart/add">. The browser's default behaviour
     POSTs the form and redirects to /cart, which means the user leaves
     the page and the drawer never opens. We intercept any submit on a
     /cart/add form, AJAX-post it, and open our custom drawer on success
     so the freshly-added line item is visible without leaving the page.
     =========================================== */
  function initAddToCartDrawer() {
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]');
        if (!form) return;

        // Skip if form is wrapped in <product-form> — Dawn handles AJAX itself.
        if (form.closest('product-form')) return;

        e.preventDefault();

        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn && submitBtn.getAttribute('aria-disabled') === 'true') return;

        var submitLabel = submitBtn ? submitBtn.textContent : '';
        var keepDisabled = false;
        if (submitBtn) {
          submitBtn.setAttribute('aria-disabled', 'true');
          submitBtn.disabled = true;
          submitBtn.classList.add('is-loading');
          if (submitBtn.dataset.loadingLabel) {
            submitBtn.textContent = submitBtn.dataset.loadingLabel;
          }
        }

        var formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        })
          .then(function (r) {
            return r.json().then(function (data) {
              if (!r.ok) throw data;
              return data;
            });
          })
          .then(function () {
            openDrawer();
          })
          .catch(function (err) {
            console.error('[custom-navbar] add-to-cart error', err);
            var description = err && (err.description || err.message);
            var isSoldOut = /sold out|unavailable|not available/i.test(description || '');

            if (isSoldOut && submitBtn) {
              keepDisabled = true;
              submitBtn.textContent = submitBtn.dataset.soldOutLabel || 'Sold Out';
              submitBtn.setAttribute('aria-disabled', 'true');
              submitBtn.disabled = true;
              submitBtn.classList.add('is-sold-out');
            } else if (description) {
              var existing = form.querySelector('[data-add-to-cart-error]');
              if (existing) existing.textContent = description;
              else alert(description);
            }
          })
          .finally(function () {
            if (submitBtn) {
              submitBtn.classList.remove('is-loading');

              if (!keepDisabled) {
                submitBtn.removeAttribute('aria-disabled');
                submitBtn.disabled = false;
              }

              if (!keepDisabled && submitBtn.dataset.loadingLabel) {
                submitBtn.textContent = submitLabel;
              }
            }
          });
      },
      false
    );
  }

  /* ===========================================
     Boot
     =========================================== */
  function init() {
    initScrollFade();
    initMegamenu();
    initCartDrawer();
    initCartSync();
    initMobileMenu();
    initSideInquiryFallback();
    initAddToCartDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.custom-navbar')) init();
  });
})();
